import React from "react";
import "./contact.css";
import ContactForm from "./Components/ContactForm";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { FaInstagram, FaTiktok } from "react-icons/fa";

export default function ContactPage() {
  return (
    <div className="page-container">
      <Navbar />
      <main className="content">
        <h2>Comentarios</h2>
        <p>
          Siempre serán bienvenidos los comentarios y críticas constructivas para mejorar la página. Te dejamos el siguiente contacto en caso de que quieras ayudarnos con eso. ¡Recuerda apoyarnos en nuestras redes sociales!
          
        </p>

        <p>Algunas ideas a futuro:</p>
        <ul className="ideas-list">
          <li>Corregir y completar la data de cartas.</li>
          <li>Sistema de creación de cuentas y guardado de mazos.</li>
          <li>Agregar los formatos libre y full en primer bloque.</li>
          <li>Ampliar la aplicación a otros bloques</li>
          <li>Más filtros y ordenar por características.</li>
        </ul>
        <div className="redes">
          <p>Redes: </p>
          <a
            href="https://www.instagram.com/elmetacl/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaInstagram className="social-icon" />
            @elmetacl
          </a>

          <a
            href="https://www.tiktok.com/@elmetacl"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <FaTiktok className="social-icon" />
            @elmetacl
          </a>
        </div>
        <div className="form-container">
          <ContactForm />
        </div>
      </main>

        <Footer />
      
    </div>
  );
}
